var TopicSelectorFieldForHandoutCreation;

TopicSelectorFieldForHandoutCreation = require('components/covid_extraction_form/topic_selector_field').TopicSelectorFieldForHandoutCreation;

module.exports = {
  HANDOUT_FORM: {
    main: [
      {
        fieldKey: 'name',
        type: 'text',
        showClear: false,
        useControlledInput: true
      }, {
        fieldKey: 'parentTopic',
        type: 'custom',
        showClear: false,
        component: TopicSelectorFieldForHandoutCreation
      }
    ]
  }
};
